import { Expose } from 'class-transformer';
export class FbItemSubArticleApiModel {
  @Expose()
  articleId: string;

  @Expose()
  quantity: number;

  @Expose()
  name: string;

  @Expose()
  taxRate: number;

  @Expose()
  price: number;

  @Expose()
  defaultPriceLevelPrice: number;

  graphics?: string[];
}
